// extracted by mini-css-extract-plugin
export default {"container":"People_container__Wi1u3","grid":"People_grid__+KFMg","alumniInformation":"People_alumniInformation__vAnSC"};